import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../../errorhandling';

let localSubscription = undefined;

// User subscription
function createSubscription(store) {
	let userQuery = new Parse.Query('User');
	userQuery.limit(10000)
	userQuery.include("dependency")
		.find()
		.then((results) => {
			store.dispatch('users/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
	userQuery.subscribe().then((subscription) => {
		localSubscription = subscription;
		
		subscription.on('create', (object) => {
			
			store.dispatch('users/insert', object)
		});
		subscription.on('update', (object) => {
			
			store.dispatch('users/replace', object)
		});
		subscription.on('enter', (object) => {
			
			store.dispatch('users/insert', object)
		});
		subscription.on('leave', (object) => {
			
			store.dispatch('users/delete', object)
		});
		subscription.on('delete', (object) => {
			
			store.dispatch('users/delete', object)
		});
		subscription.on('close', () => {
			
		});
	})
}

export default function createUserSubscription() {
	return store => {
		//Erzeuge einmalig eine neue Subscription für den Datensatz. 
		//Fall "Bereits in der Anwendung"
		if(store.state.currentUser && !localSubscription) {
			createSubscription(store)
		}
		//Erzeuge einmalig eine neue Subscription für den Datensatz. 
		//Fall "Normaler Login"
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER' && store.state.currentUser) {
				if (!localSubscription) {
					createSubscription(store)
				}
			}
		})
	}
}
